import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesChannelIface } from '../../interfaces/sales-channel.iface';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { SalesChannelService } from '../../services/sales-channel.service';
import { SalesChannelEditionDialogComponent } from './sales-channel-edition-dialog/sales-channel-edition-dialog.component';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-sales-channel',
  templateUrl: './sales-channel.component.html',
  styleUrls: ['./sales-channel.component.scss']
})
export class SalesChannelComponent implements OnInit {
  public isLoadingResults = true;
  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  public dataSource: MatTableDataSource<SalesChannelIface> = new MatTableDataSource([]);
  public displayedColumns = ['name', 'updatedBy', 'updatedAt', 'edit', 'delete'];

  constructor(
    private salesChannelService: SalesChannelService,
    private matDialog: MatDialog,
    private toastr: ToastsManager,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.salesChannelService.getChannels().subscribe(salesChannels => {
      this.dataSource.data = salesChannels;
      this.isLoadingResults = false;
      this.paginator.length = this.dataSource.data.length;
      this.paginator.pageSize = 10;
      this.dataSource.paginator = this.paginator;
    });
  }

  openSalesChannelEditionDialog(salesChannel: SalesChannelIface = {} as SalesChannelIface): void {
    this.matDialog
      .open(SalesChannelEditionDialogComponent, { data: salesChannel })
      .afterClosed()
      .subscribe(updatedChannel => {
        if (salesChannel._id) {
          this.dataSource.data = this.dataSource.data.map(document => {
            if (document._id === salesChannel._id) {
              return updatedChannel;
            }
            return document;
          });
        } else {
          this.dataSource.data = [...this.dataSource.data, ...updatedChannel];
        }
      });
  }

  removeChannel(id: string, channelName: string): void {
    this.matDialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'SALES_CHANNEL.DELETE_DIALOG.TITLE',
          body: 'SALES_CHANNEL.DELETE_DIALOG.BODY',
          translateParams: {
            salesChannel: channelName
          }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => this.salesChannelService.removeChannel(id))
      )
      .subscribe(
        () => {
          this.toastr.info(this.translateService.instant('SALES_CHANNEL.TOASTR.INFO.REMOVE'));
          this.dataSource.data = this.dataSource.data.filter(document => document._id !== id);
        },
        () => {
          this.toastr.error(this.translateService.instant('SALES_CHANNEL.TOASTR.ERROR.REMOVE'), 'Ooops!');
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sales-channels/sales-channel.component.ts